import React, { Component } from 'react'
import { Card, Button, Row, Col } from 'react-bootstrap'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'

import { renderTextField } from '../../../Forms/fieldRenderers'
import { required } from '../../../Forms/fieldValidators'
import Grid from '@material-ui/core/Grid'
import { FORM_EDICION_CANTIDAD_CUPO } from '../../../../config/forms'

const number = value => value && isNaN(Number(value)) ? 'Debe ingresar un valor Numérico' : undefined
const selector = formValueSelector(FORM_EDICION_CANTIDAD_CUPO)

class DialogoCupoUpdate extends Component {
  constructor (props) {
    super(props)
    const { data, usuario } = this.props
    this.datosDeCupoCache = {
      fechaDeEmision: data[0],
      cereal: data[1],
      exportador: data[10],
      cargador: data[4],
      corredor: data[6],
      cantidadNominada: data[7],
      usuario: usuario
    }
  }

  async componentDidMount () {
    const { change: formChange } = this.props
    formChange('cantidad', this.datosDeCupoCache.cantidadNominada)
  }

  render () {
    const {
      handleClose,
      handleSubmit,
      nuevaCantidad
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Modificar cantidad</Card.Text>
          </Card.Header>
          <Card.Body>
            <Row>
              <Grid container justify='space-around'>
                <Col md={4} />
                <Col md={4}>
                  <Field
                    name='cantidad'
                    type='number'
                    label='Cantidad'
                    component={renderTextField}
                    autoFocus={false}
                    validate={[required, number]}
                    placeholder=''
                  />
                </Col>
                <Col md={4} />
              </Grid>
            </Row>
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button>
            <Button style={{ margin: '2%' }} onClick={() => handleSubmit(this.datosDeCupoCache, nuevaCantidad)} >Guardar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.auth.username,
    nuevaCantidad: selector(state, 'cantidad')
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_EDICION_CANTIDAD_CUPO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCupoUpdate))
